import { useTranslation } from "react-i18next";

export const useMultipleSelectionLabel = () => {
	const { t } = useTranslation();

	const getMultipleSelectionLabel = <T>(
		opts: Array<{ value: T; label: string }>,
		values: T[],
	): string => {
		if (!values || values.length === 0) return "";
		if (values.length === 1) {
			return opts.find((o) => o.value === values[0])?.label ?? "";
		}
		return t("common.selected-count", { count: values.length });
	};

	return { getMultipleSelectionLabel };
};
